// extracted by mini-css-extract-plugin
module.exports = {"button":"ToggleButton_button__1wPKm","active":"ToggleButton_active__3e4g4"};